<template>
  <div class="columns profile--settings">
    <settings-section
      :title="$t('WISE_SETTINGS.AGENTS.TITLE')"
      :sub-title="$t('WISE_SETTINGS.AGENTS.SUB_TEXT')"
    >
      <multiselect
        v-model="selectedAgents"
        :options="agentList"
        track-by="id"
        label="name"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :hide-selected="true"
        :placeholder="$t('WISE_SETTINGS.AGENTS.PLACEHOLDER')"
        selected-label
        :select-label="$t('FORMS.MULTISELECT.CLICK_TO_SELECT')"
        :deselect-label="$t('FORMS.MULTISELECT.CLICK_TO_REMOVE')"
        @select="$v.selectedAgents.$touch"
      />

      <woot-submit-button
        :button-text="$t('WISE_SETTINGS.FORM.SUBMIT')"
        :loading="isUpdating"
        @click="updateAgents"
      />
    </settings-section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import accountMixin from '../../../../mixins/account';
import SettingsSection from '../../../../components/SettingsSection';

export default {
  components: {
    SettingsSection,
  },
  mixins: [accountMixin, alertMixin],
  data() {
    return {
      selectedAgents: [],
      isUpdating: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
      getAccount: 'accounts/getAccount',
    }),
    currentAccount() {
      return this.getAccount(this.accountId) || {};
    },
  },
  mounted() {
    this.fetchAgents();
    this.fetchWiseAgents();
  },
  methods: {
    async fetchAgents() {
      try {
        await this.$store.dispatch('agents/get');
      } catch (error) {
        this.showAlert(this.$t('WISE_SETTINGS.AGENTS.FETCH_ERROR'));
      }
    },
    async fetchWiseAgents() {
      try {
        const agentsWithPermission = this.agentList.filter(
          agent => agent.permissions?.can_see_wise
        );
        this.selectedAgents = agentsWithPermission;
      } catch (error) {
      }
    },
    async updateAgents() {
      this.isUpdating = true;
      try {
        const updatePromises = this.agentList.map(agent => {
          const hasPermission = this.selectedAgents.some(
            selected => selected.id === agent.id
          );
          
          return this.$store.dispatch('agents/update', {
            id: agent.id,
            permissions: {
              ...agent.permissions,
              can_see_wise: hasPermission,
            },
          });
        });

        await Promise.all(updatePromises);
        
        this.showAlert(this.$t('WISE_SETTINGS.FORM.SUCCESS_MESSAGE'));
        await this.fetchAgents();
      } catch (error) {
        this.showAlert(
          error.message || this.$t('WISE_SETTINGS.FORM.ERROR_MESSAGE')
        );
      } finally {
        this.isUpdating = false;
      }
    },
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return true;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.profile--settings {
  padding: var(--space-normal);
}
</style>

